var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M22,24H2a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z"}}),_c('path',{attrs:{"d":"M20.707,4.293l-3-3a1,1,0,0,0-1.414,0l-12,12a1,1,0,0,0-.263.465L2,20l6.242-2.03a1,1,0,0,0,.465-.263l12-12A1,1,0,0,0,20.707,4.293Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }